$(function() {
    var
        $video_section = $('.elevator-pitch-video'),
        $video_container = $('.elevator-pitch-video-container');

    if ($video_section.hasClass('scroll_into_view')) {
        window.setTimeout(function() {
            $('html, body').animate({ scrollTop: $video_section.offset().top }, 300);
        }, 500);
    }

    $(document).on('click', '.elevator-pitch-video .video-thumb', function(e) {
        var video = $(this);
        $.ajax({
            url: '/' + BB_DIR_WEBROOT + '/index.php/tools/packages/video_v3/ajax.php',
            data: {
                action: 'multiple_video_tool_load_iframe',
                video_id: video.attr('data-video-id')
            },
            type: 'POST',
            dataType: 'html',
            beforeSend: function() {
                // alert(this.dataset.videoId);
            },
            success: function(html) {
                $video_container.html(html);
                $('.video-thumb-active').removeClass('video-thumb-active');
                video.addClass('video-thumb-active');
            }
        });
    });
});
